import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Users, UserCheck, Tractor, Inbox, Mail, Settings, LogOut, Megaphone } from "lucide-react";
import { Logo } from "@/components/site/Navbar";
import { ThemeToggle } from "@/components/site/ThemeToggle";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";

const NAV = [
  ["applicants", "Applicants", Users],
  ["members", "Members", UserCheck],
  ["farms", "Farms", Tractor],
  ["inbox", "Inbox", Inbox],
  ["emails", "Emails", Mail],
  ["announcements", "Announcements", Megaphone],
  ["settings", "Settings", Settings],
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const out = async () => {
    await logout();
    nav("/login");
  };
  return (
    <div className="min-h-screen flex flex-col lg:flex-row" data-testid="admin-layout">
      <aside className="lg:w-64 lg:fixed lg:inset-y-0 border-b lg:border-b-0 lg:border-r border-border bg-card flex lg:flex-col">
        <div className="hidden lg:block p-6"><Logo /></div>
        <nav className="flex flex-wrap lg:flex-nowrap lg:flex-col gap-1 px-3 py-3 lg:py-0 flex-1">
          {NAV.map(([to, label, Icon]) => (
            <NavLink
              key={to}
              to={`/admin/${to}`}
              data-testid={`admin-nav-${to}`}
              className={({ isActive }) => cn("flex items-center gap-3 whitespace-nowrap rounded-xl px-4 py-2.5 text-sm font-semibold transition-colors", isActive ? "bg-primary text-primary-foreground" : "hover:bg-secondary")}
            >
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:block p-4 border-t border-border space-y-3">
          <p className="text-xs text-muted-foreground truncate" data-testid="admin-user-email">{user?.email}</p>
          <div className="flex items-center gap-2">
            <ThemeToggle />
            <button onClick={out} data-testid="admin-logout-button" className="flex-1 h-10 rounded-full border border-border text-sm font-semibold inline-flex items-center justify-center gap-2 hover:bg-secondary transition-colors"><LogOut className="h-4 w-4" />Log out</button>
          </div>
        </div>
      </aside>
      <div className="lg:hidden order-first flex items-center justify-between px-4 py-3 border-b border-border">
        <Logo />
        <div className="flex gap-2"><ThemeToggle /><button onClick={out} data-testid="admin-logout-button-mobile" className="h-10 w-10 grid place-items-center rounded-full border border-border"><LogOut className="h-4 w-4" /></button></div>
      </div>
      <main className="flex-1 lg:ml-64 p-4 sm:p-8 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}

export const PageTitle = ({ title, sub, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
    <div>
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">{title}</h1>
      {sub && <p className="text-muted-foreground mt-1">{sub}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);
